"use client"

import NilaiLogoCard from "@/app/Components/NilaiLogoCard";
import { NilaiLogos } from "../constant";

const NilaiLogo = () => {
  return (
    <div className="relative flex flex-col justify-center items-start w-full px-5 md:px-10 lg:px-20 gap-10 overflow-hidden">
      <h3 className="flex items-center gap-5 text-cust-blue font-semibold text-4xl md:text-5xl text-center lg:text-left">
        Arti Nilai di Balik Desain Logo
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 w-full">
        {NilaiLogos.map((nilai, index) => (
          <NilaiLogoCard
            key={index} // React's internal key (does not pass as prop)
            index={index + 1} // Pass this prop for animation logic
            image={nilai.image}
            title={nilai.title}
            description={nilai.description}
          />
        ))}
      </div>
    </div>
  );
};

export default NilaiLogo;
